/* Package JSON Import will be here */
import xlsx from "json-as-xlsx";
import { forEach } from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getErrorObject, errorToast } from "../../utilities/utils";
import { getRetailerLedgerApi } from "services/reports/retailerLedger";
import { IRetailerLedgerParams } from "../../models/reports/retailerLedgerModels";
import Constants from "utilities/appConstants";
import { showMsgFromJson } from "reducers/common";
/* Project Import will be here */

export const types = {
    RETAILER_LEDGER_REQUEST: "retailerLedger/retailerLedgerRequest",
    RETAILER_LEDGER_SUCCESS: "retailerLedger/retailerLedgerSuccess",
    RETAILER_LEDGER_FAILURE: "retailerLedger/retailerLedgerFailure"
};

let initialState = {
    isLoading: false,
    data: [],
    error: null
};

export const retailerLedger = (state = initialState, action) => {
    switch (action.type) {
        case types.RETAILER_LEDGER_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case types.RETAILER_LEDGER_SUCCESS:
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                error: null
            };
        case types.RETAILER_LEDGER_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error
            };
        default:
            return state;
    }
};

/* Get retailer ledger to download */
export const getRetailerLedger = (value: IRetailerLedgerParams) => {
    return async (dispatch, getState) => {
        const loggedInUserDetails = getState().localStore.user;

        dispatch({
            type: types.RETAILER_LEDGER_REQUEST
        });

        try {
            /* Handling request params */
            const requestData: IRetailerLedgerParams = {
                RetailerCode: loggedInUserDetails.retailercode,
                DistributorCode: loggedInUserDetails.distributorcode,
                Month: value.Month,
                Year: value.Year
            };
            const response = await getRetailerLedgerApi(requestData);

            dispatch({
                type: types.RETAILER_LEDGER_SUCCESS,
                payload: { data: response.data.Data }
            });

            /* Export the json data in excel sheet */
            if (response.data.Data.length > 0) {
                /* Prepare header */
                let excelHeader = [];
                forEach(Object.keys(response.data.Data[0]), (o) => {
                    excelHeader.push({ label: o, value: o })
                });

                const excelExportData = [{
                    columns: excelHeader,
                    content: response.data.Data
                }];
                const excelSettings = {
                    fileName: `${Constants.DOWNLOAD_FILE_NAME}-${value.Month}-${value.Year}`,
                    extraLength: 3,
                    writeOptions: {}
                }

                /* Download the excel */
                xlsx(excelExportData, excelSettings);
            }
            else {
                dispatch(showMsgFromJson(`common.alerts.error.noRetailerLedgerError`, Constants.ERROR));
            }
        }
        catch (error) {
            const { message, errorCode } = getErrorObject(error);
            dispatch({
                type: types.RETAILER_LEDGER_FAILURE,
                payload: { error: message }
            });

            if (errorCode !== "" && errorCode === Constants.DMS_SESSION_EXPIRED)
                dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
            else
                errorToast({ content: message });
        }
    }
};
